export class ErzeugungsanlageConfig {

    public static readonly HORIZONTAL_FX_LAYOUT_GAP = '1rem';
    public static readonly VERTICAL_FX_LAYOUT_GAP = '1rem';

    public static readonly ANLAGENKENNLINIE_MIN_ERROR = 'Es sind mindestens 15 Felder zu befüllen.';

    public static readonly ABREGELINFOS_ADDR_IEC_FX_FLEX_COL = [
        '',
        '200px',
        '200px',
        '200px',
        '200px',
        '40px',
    ];
    public static readonly ABREGELINFOS_ADDR_TASE_FX_FLEX_COL = [
        '',
        '400px',
        '200px',
        '40px',
    ];
}
